import { render, staticRenderFns } from "./glip-integration-accordion.vue?vue&type=template&id=fa455730&scoped=true&"
import script from "./glip-integration-accordion.vue?vue&type=script&lang=ts&"
export * from "./glip-integration-accordion.vue?vue&type=script&lang=ts&"
import style0 from "./glip-integration-accordion.vue?vue&type=style&index=0&id=fa455730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa455730",
  null
  
)

export default component.exports